// Tiny pub-sub for toast notifications - same pattern already used for
// admin-auth-changed (a plain window CustomEvent), so any class component
// anywhere in the app can fire a toast with one call, without lifting
// state or wiring context/redux through ~8 admin pages just for this.
export const TOAST_EVENT = 'app-toast';

// type: 'success' | 'error' | 'info'
export const showToast = (message, type = 'success') => {
    window.dispatchEvent(new CustomEvent(TOAST_EVENT, { detail: { message, type } }));
};
